"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hooks = require("../../../hooks");
var _mixins = require("../mixins");
var _constants = require("../constants");
var _mixins2 = require("../../../mixins");
var _useDataAttributes = require("../../../hooks/use-data-attributes");
var _excluded = ["as", "children", "large"];
var StyledHeader = _styledComponents["default"].h3.withConfig({
  displayName: "section-header__StyledHeader"
})(["", " ", " ", " font-weight:", ";font-size:", ";line-height:", ";padding-top:2rem;"], _mixins2.mixins.spacingReset, _mixins.mixins.inlineIcon, _mixins.mixins.font, _constants.FONT_WEIGHTS.normal, function (_ref) {
  var $large = _ref.$large;
  return $large ? '2.5rem' : '1.5rem';
}, function (_ref2) {
  var $large = _ref2.$large;
  return $large ? '2.5rem' : '2rem';
});
var SectionHeader = exports.SectionHeader = function SectionHeader(_ref3) {
  var _ref3$as = _ref3.as,
    as = _ref3$as === void 0 ? 'h3' : _ref3$as,
    children = _ref3.children,
    _ref3$large = _ref3.large,
    large = _ref3$large === void 0 ? false : _ref3$large,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var dataAttributes = (0, _useDataAttributes.useDataAttributes)(rest);
  var _useBonsai = (0, _hooks.useBonsai)(),
    primaryFont = _useBonsai.primaryFont,
    primaryFontColor = _useBonsai.primaryFontColor;
  return /*#__PURE__*/_react["default"].createElement(StyledHeader, (0, _extends2["default"])({
    as: as,
    $color: primaryFontColor,
    $font: primaryFont,
    $large: large
  }, dataAttributes), children);
};